import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';

// @Component({
//   selector: 'app-add-institution-dialog',
//   templateUrl: './add-institution-dialog.component.html',
//   styleUrls: ['./add-institution-dialog.component.scss']
// })
// export class AddInstitutionDialogComponent implements OnInit {

  @Component({
  selector: 'app-drive-add-branch',
  templateUrl: './drive-add-branch.component.html',
  styleUrls: ['./drive-add-branch.component.scss']
})
export class DriveAddBranchComponent implements OnInit {

  collegeNameArr = ['college1','college2','college3'];

  constructor(
    public dialogRef: MatDialogRef<DriveAddBranchComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log("Name",name); 
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  name = new FormControl('', [Validators.required]);
  collegeName = new FormControl('', [Validators.required]);
  shortName = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
  branchName = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
  city = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
  address = new FormControl('', [Validators.required]);
  url = new FormControl('', [Validators.required]);

  getErrorMessageOfCollegeName() {
    return this.collegeName.hasError('required') ? 'You must enter a value' :'';
  }

  getErrorMessageOfShortName() {
    return this.shortName.hasError('required') ? 'You must enter a value' :'';
  }

  getErrorMessageOfBranchName() {
    return this.branchName.hasError('required') ? 'You must enter a value' :'';
  }

  getErrorMessageOfCity() {
    return this.city.hasError('required') ? 'You must enter a value' :'';
  }

  getErrorMessageOfAddress() {
    return this.address.hasError('required') ? 'You must enter a value' :'';
  }

  getErrorMessageOfURL() {
    return this.url.hasError('required') ? 'You must enter a value' :'';
  }


}





// import { Component, OnInit, Inject } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
// import { Validators, FormControl } from '@angular/forms';

// @Component({
//   selector: 'app-drive-add-branch',
//   templateUrl: './drive-add-branch.component.html',
//   styleUrls: ['./drive-add-branch.component.scss']
// })
// export class DriveAddBranchComponent implements OnInit {

//   constructor(
//     public dialogRef: MatDialogRef<DriveAddBranchComponent>,
//     @Inject(MAT_DIALOG_DATA)private data:any,
//   ) { }

//   collegeName = new FormControl('', [Validators.required]); 
//   shortName = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
//   branch = new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
//   city = new FormControl('',[Validators.required, Validators.pattern('^[a-zA-Z ]*$')]);
//   address = new FormControl('',[Validators.required]);
//   url = new FormControl('',[Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]);

//   isSubmit:boolean;
// selected='option1';
//   ngOnInit() {
   
//   }
//   onCloseDialog(){
//     this.dialogRef.close();
    
//   }

//   getErrorMessageOfShortName(){
//     return this.shortName.hasError('required') ? 'Enter short name' : 
//     this.shortName.hasError('pattern') ? 'Enter alphabates value only' : '';
//   }

//   getErrorMessageOfBranch(){
//     return this.branch.hasError('required') ? 'Enter value' :
//     this.branch.hasError('pattern') ? 'Enter alphabates value only' : '';
//   }
  
//   getErrorMessageOfCity(){
//     return this.city.hasError('required') ? 'Enter city name' :
//     this.city.hasError('pattern') ? 'Enter alphabates value only' : '';
//   }

//   getErrorMessageOfUrl(){
//     return this.url.hasError('required') ? 'Enter url' :
//     this.url.hasError('pattern') ? 'url incorrect' : '';
//   }
// }
